import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const PRACTICE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/9f7a8f43-4f45-4bb8-9b7a-264c329c2ef0.jpg';
const PILLARS = [{
  title: 'Breath',
  text: 'Slow, steady, unhurried. The same air that moves through the trees moves through you, and following it is how we begin.'
}, {
  title: 'Stillness',
  text: 'When the noise settles, the world gets louder in the best way: waves, wind, your own heartbeat. Rest here as long as you need.'
}, {
  title: 'Belonging',
  text: 'You are not a guest in nature. You are made of it, and remembering that is what makes the ground feel solid again.'
}];
export function Philosophy() {
  return <section id="philosophy" className="relative w-full bg-cream py-24 md:py-36" data-id="element-93" data-mp="2m8lx7uf6v6i0">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-6 md:grid-cols-[1fr_1.05fr] md:gap-20 md:px-10" data-id="element-94" data-mp="fe8ffvg45n9e">
        <Reveal className="order-2 md:order-1" data-id="element-95" data-mp="17becijmzvia3">
          <img src={PRACTICE_IMAGE} alt="A single outstretched wing drifting through a pastel sky, one feather falling below it" className="aspect-[4/5] w-full object-cover" data-id="element-96" data-mp="17a394kxgocji" />
        </Reveal>

        <div className="order-1 md:order-2" data-id="element-97" data-mp="1h31xq2syk334">
          <Reveal data-id="element-98" data-mp="1c35uw6vzyhp5">
            <SectionLabel align="left" data-id="element-99" data-mp="1c2o2jlcggnmi">The Practice</SectionLabel>
          </Reveal>

          <Reveal delay={0.1} data-id="element-100" data-mp="odldhsfhrshz">
            <h2 className="mt-8 font-display text-4xl font-light leading-[1.15] text-ink sm:text-5xl lg:text-[3.6rem]" data-id="element-101" data-mp="oemltp54i0w0">
              A space devoted to
              <br data-id="element-102" data-mp="yazohcinbp2w" />
              <span className="italic text-clay" data-id="element-103" data-mp="ybix22mep149">stillness, breath</span> &amp;
              <br data-id="element-104" data-mp="tbdav1ywo6tk" />
              our belonging to nature
            </h2>
          </Reveal>

          <Reveal delay={0.18} data-id="element-105" data-mp="29p3jmm0yzj9j">
            <p className="mt-8 max-w-prose text-[15px] font-light leading-[1.9] text-muted" data-id="element-106" data-mp="29obnna3gnjiq">
              PARṆA, the Sanskrit word for wing, feather, leaf, exists to reconnect people with
              the natural world. We believe the body is not separate from the earth that made it:
              the same breath moves through the forest and through your lungs, the same rhythms
              turn the tide and your pulse.
            </p>
          </Reveal>

          <Reveal delay={0.22} data-id="element-107" data-mp="2qrsgxct6mv33">
            <p className="mt-5 max-w-prose text-[15px] font-light leading-[1.9] text-muted" data-id="element-108" data-mp="2qqqwihqa0w8p">
              Through yoga, meditation, and mindful movement, practiced in the open air wherever
              we can, we slow down enough to feel that kinship again. Every class is an
              invitation back into the living world you are already part of.
            </p>
          </Reveal>

          <Reveal delay={0.26} data-id="element-109" data-mp="27t6jc7wvjm3x">
            <dl className="mt-12 grid gap-8 border-t border-clay/15 pt-10 sm:grid-cols-3" data-id="element-110" data-mp="27uhly4el2ntg">
              {PILLARS.map(pillar => <div key={pillar.title} data-id="element-111" data-mp="1fbkcf5u6x9os">
                  <dt className="font-display text-lg font-light tracking-wide text-ink" data-id="element-112" data-mp="1faj2j4owut8n">
                    {pillar.title}
                  </dt>
                  <dd className="mt-2 text-[13px] font-light leading-relaxed text-muted" data-id="element-113" data-mp="12trhhdb0617w">
                    {pillar.text}
                  </dd>
                </div>)}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>;
}